import { render, staticRenderFns } from "./ListTipotelefonePage.vue?vue&type=template&id=9cb05ef4"
import script from "./ListTipotelefonePage.vue?vue&type=script&lang=js"
export * from "./ListTipotelefonePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports